<i18n>
en:
  loginId:
    label: "E-mail"
    placeholder: "reiwa@tebsta.com"
  password:
    label: "Password"
  forget:
    before: " "
    label: "Click"
    after: "here if you forget your password"
  signup:
    user:
      label: "Sign up"
    shop:
      label: "Store entry"
  submit: "Sign in"
  error:
    WLO001: "I could not login<br>Please check your email address and password"

ja:
  loginId:
    label: "メールアドレス"
  password:
    label: "パスワード"
  forget:
    before: "※パスワードを忘れた場合は"
    label: "こちら"
    after: " "
  signup:
    user:
      label: "ユーザーの新規作成"
    shop:
      label: "店舗の新規登録"
  submit: "ログイン"
  error:
    WLO001: "ログイン出来ませんでした<br>メールアドレスとパスワードを確認してください"
</i18n>

<template lang="pug">
  div.my-6
    v-container
      v-form(onsubmit="return false" v-model="valid")
        v-row(justify="center")
          v-col(cols="12" sm="6" md="4" xl="2")
            v-text-field.required(prepend-icon="fa-envelope" :label="$t('loginId.label')" :rules="v($t('loginId.label'), ['required', 'mail'])" v-model="forms.loginId")

        v-row(justify="center")
          v-col(cols="12" sm="6" md="4" xl="2")
            v-text-field.required(type="password" prepend-icon="fa-key" :label="$t('password.label')" :rules="v($t('password.label'), ['required'])" v-model="forms.password")

        //- 送信ボタン
        v-row(justify="center")
          v-col(cols="12" sm="6" md="4" xl="2")
            v-btn(x-large block color="primary" type="submit" @click="submit" :loading="isSubmit" :disabled="!valid")|{{$t('submit')}}

        //- エラーメッセージ
        v-row(v-if="errMsg")
          v-col(cols="12" align="center")
            v-alert.d-inline-block(dense outlined type="error")
              div(v-html="errMsg")

        //- リンク
        v-row
          v-col(cols="12" align="center" height="36px")
            |{{$t('forget.before')}}&nbsp;
            strong
              a(href="#" @click="$router.push({name: 'PassForget'})")|{{$t('forget.label')}}
            |&nbsp;{{$t('forget.after')}}
        v-row(justify="center")
          v-col.mt-12.pa-1(cols="12" sm="6" md="4" xl="2" align="center")
            strong
              a(href="#" @click="$router.push({name: 'EntryFirst', params: {kind: '0'}})")|{{$t('signup.user.label')}}
        v-row(justify="center")
          v-col.pa-1(cols="12" sm="6" md="4" xl="2" align="center")
            strong
              a(href="#" @click="$router.push({name: 'EntryFirst', params: {kind: '1'}})")|{{$t('signup.shop.label')}}
</template>

<script>
export default {
  data () {
    return {
      // 入力フォーム
      forms: {
        loginId: null,
        password: null
      },
      // 入力バリデーション
      valid: false,
      // 送信中
      isSubmit: false,
      // エラーメッセージ
      errMsg: null
    }
  },
  watch: {
    /**
     * 認証情報
     * （リロードなど、認証情報取得が遅れると一旦Loginに来るので、watchで取得次第元の画面へ遷移）
     */
    '$store.getters.login_isLogin' (val) {
      if (val) {
        const name = this.$route.query.next
        if (name) {
          this.$router.push({name, params: this.$route.params})
        } else {
          this.$router.push('/')
        }
      }
    }
  },
  methods: {
    /**
     * 送信
     */
    submit () {
      if (this.isSubmit) {
        return
      }

      this.isSubmit = true
      this.errMsg = null

      this.api.certify({
        loginId: this.forms.loginId,
        password: this.forms.password
      })
        .then(response => {
          this.$store.commit('login_info', response.data)
        })
        .catch(response => {
          this.errMsg = this.$t(`error.${response.functionError.errorCode}`)
        })
        .finally(() => {
          this.isSubmit = false
        })
    }
  }
}
</script>

<style lang="sass" scoped>
</style>
